// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Fonts$PrezzeeRibbon from "../../../theme/Theme__Fonts.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

function Component(T) {
  var container = BsCssJs$PrezzeeRibbon.style([
        BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(25)),
        BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(12))]),
        BsCssJs$PrezzeeRibbon.selector("button", [
              Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
              BsCssJs$PrezzeeRibbon.cursor("pointer"),
              BsCssJs$PrezzeeRibbon.display("inlineFlex"),
              BsCssJs$PrezzeeRibbon.alignItems("center"),
              BsCssJs$PrezzeeRibbon.justifyContent("center"),
              BsCssJs$PrezzeeRibbon.backgroundColor("transparent"),
              BsCssJs$PrezzeeRibbon.borderWidth("zero"),
              BsCssJs$PrezzeeRibbon.fontWeight("normal"),
              BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(16)),
              BsCssJs$PrezzeeRibbon.padding("zero"),
              BsCssJs$PrezzeeRibbon.color(T.textColour),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [
                    BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(18)),
                    BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(30))
                  ]),
              BsCssJs$PrezzeeRibbon.selector("&:focus", [BsCssJs$PrezzeeRibbon.outlineWidth("zero")])
            ]),
        BsCssJs$PrezzeeRibbon.selector("img", [
              BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(11)),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(14))])
            ])
      ]);
  var Styles = {
    container: container
  };
  var FullWidthHero__CtaLineVideo$Component = function (props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return JsxRuntime.jsx("div", {
                children: props.children,
                className: Classnames([
                      container,
                      className$1
                    ])
              });
  };
  return {
          Styles: Styles,
          make: FullWidthHero__CtaLineVideo$Component
        };
}

export {
  Component ,
}
/* classnames Not a pure module */
